import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import ContentArea from '~/shared/components/ContentArea';
import {
  mobile,
  Separator,
  SkeletonLine,
} from '~/techstyle-shared/react-components';

import { ProductDetailsLoading } from '../ProductDetails';

const MainContent = styled.main`
  margin: 32px auto 0;

  ${mobile`
    margin-top: 0;
  `};
`;

const MobileHeaderWrapper = styled.div`
  grid-area: mobileHeaderArea;
  margin: 0;
  padding: 16px;
  width: 100%;
  display: block;
`;

const MainProductArea = styled.div`
  margin-bottom: 32px;
  display: grid;
  grid-template-columns: fit-content(320px) minmax(0, 1fr);
  grid-template-areas:
    'mobileHeaderArea mobileHeaderArea'
    'productImageArea productDetailArea';

  ${mobile`
    flex-direction: column;
    grid-template-columns: 1fr;
    grid-template-areas: "mobileHeaderArea"
                         "productImageArea"
                         "productDetailArea";
  `}
`;

const ProductDetailWrapper = styled.div`
  grid-area: productDetailArea;
  display: flex;
  flex-direction: column;

  ${mobile`
    max-width: 100vw;
    margin-left: 0;
  `}
`;

const separatorStyle = css`
  color: ${({ theme }) => theme.colors.separator};
  margin-block: 14px 16px;
`;

const SkeletonLineWithMarginBottom = styled(SkeletonLine)`
  margin-bottom: ${(props) =>
    props.$marginBottom ? `${props.$marginBottom}px` : 0};
`;

const ProductImageArea = styled.div`
  grid-area: productImageArea;
`;

const DesktopHeaderWrapper = styled.div`
  ${({ theme }) => theme.pdpStyles.productNameMargin};
`;

const PriceWrapper = styled.div`
  ${mobile`
    padding: 16px;
  `};
`;

const ReviewsWrapper = styled.div`
  ${({ theme }) => theme.reviewsSummaryWrapper};
`;

const LineLoaderWithContainer = (props) => {
  return (
    <div>
      <SkeletonLineWithMarginBottom {...props} />
    </div>
  );
};

const ContentWrapper = styled(ContentArea)`
  width: 100%;

  ${mobile`
    padding: 16px;
  `}
`;

const ReviewSectionLoader = () => {
  return (
    <ContentWrapper>
      <SkeletonLine />
    </ContentWrapper>
  );
};
const PDPProductLoading = ({ contentArea, productImagesLoading }) => {
  const ProductContentArea = contentArea;
  const ProductImagesLoading = productImagesLoading;
  return (
    <MainContent>
      <ProductContentArea>
        <MainProductArea>
          <MobileHeaderWrapper>
            <LineLoaderWithContainer $marginBottom={10} />
            <LineLoaderWithContainer $marginBottom={10} />
          </MobileHeaderWrapper>
          <ProductImageArea>
            <ProductImagesLoading />
          </ProductImageArea>
          <ProductDetailWrapper>
            <DesktopHeaderWrapper>
              <LineLoaderWithContainer $marginBottom={10} width={150} />
              <LineLoaderWithContainer $marginBottom={20} width={200} />
            </DesktopHeaderWrapper>
            <PriceWrapper>
              <LineLoaderWithContainer $marginBottom={10} width={100} />
              <LineLoaderWithContainer $marginBottom={10} width={100} />
            </PriceWrapper>
            <Separator thickness={1} separatorStyle={separatorStyle} />
            <ProductDetailsLoading />
          </ProductDetailWrapper>
        </MainProductArea>
        <Separator thickness={1} separatorStyle={separatorStyle} />
        {/* <UpsellModuleLoading />
            Heavy lift for upsell loader to create skeleton for a "carousel"
            and it should track loading in useRecommendedProducts not the product loading
          */}
      </ProductContentArea>
      <ReviewsWrapper>
        <ReviewSectionLoader />
      </ReviewsWrapper>
    </MainContent>
  );
};

PDPProductLoading.propTypes = {
  contentArea: PropTypes.elementType,
  productImagesLoading: PropTypes.func,
};

export default PDPProductLoading;
